import {
  LOGIN_EDITFORM_CHANGE,
  LOGIN_LOGIN_LOAD,
  LOGIN_LOGIN_SUCCEED,
  LOGIN_LOGIN_FAIL,
  LOGIN_MFA_REQUIRED,
  LOGIN_MFA_RESET,
} from '../constants/actionTypes'

const initialState = {
  formFieldValues: {},
  isLoginLoading: false,
  isLoginSuccess: false,
  loginError: null,
  mfaRequired: false,
  mfaType: null,
  mfaUserId: null,
  mfaEmail: null,
  mfaPassword: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_EDITFORM_CHANGE:
      return {
        ...state,
        formFieldValues: { ...state.formFieldValues, ...action.field },
        isLoginLoading: false,
      }
    case LOGIN_LOGIN_LOAD:
      return {
        ...state,
        isLoginLoading: true,
        loginError: null,
        isLoginSuccess: false,
      }
    case LOGIN_LOGIN_SUCCEED:
      return {
        ...state,
        formFieldValues: {},
        isLoginLoading: false,
        isLoginSuccess: true,
        mfaRequired: false,
        mfaType: null,
        mfaUserId: null,
        mfaEmail: null,
        mfaPassword: null,
      }
    case LOGIN_LOGIN_FAIL:
      return {
        ...state,
        isLoginLoading: false,
        loginError: action.loginError,
      }
    case LOGIN_MFA_REQUIRED:
      return {
        ...state,
        isLoginLoading: false,
        mfaRequired: true,
        mfaType: action.mfaType,
        mfaUserId: action.userId,
        mfaEmail: action.email,
        mfaPassword: action.password,
      }
    case LOGIN_MFA_RESET:
      return {
        ...state,
        mfaRequired: false,
        mfaType: null,
        mfaUserId: null,
        mfaEmail: null,
        mfaPassword: null,
        loginError: null,
      }
    default:
      return state
  }
}
